export interface ITextRaimbowProps {
    text: string;
    className?: string;
}
export const TextRaimbow: React.FC<ITextRaimbowProps> = (props) => {
    const { text, className = '' } = props;
    return <span className={'body bg-clip-text text-transparent bg-gradient-to-r ' + className}>{text}</span>;
};
